<template>
  <div class="doc-container">
    <h1>赛刻体育隐私政策</h1>
<p>更新日期：2026年【5】月【25】日</p>
<p>【前言】</p>
<p>欢迎使用“赛刻体育”提供的服务。“赛刻体育”是由【北京赛刻科技有限公司】自主开发的一款体育赛事快讯比分APP，具有完整的知识产权。</p>
<p>赛刻体育（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品（或服务）前，仔细阅读并了解本隐私政策。</p>
<p>【特别提示】</p>
<p>1、感谢您对赛刻体育的使用及信任，我们将持续致力于为您提供更加安全可靠的服务。</p>
<p>2、赛刻体育平台所有的产品和服务均适用本隐私政策，但某些特定产品和/或服务还将适用特定的隐私政策。</p>
<p>3、除非本隐私政策另有明确所指，本隐私政策不适用于通过我们的产品和/或服务而接入的由第三方独立为您提供的产品和/或服务的情形，例如产品的赛事分析数据。请注意，如果您使用第三方的产品和／或服务时向其提供您的个人信息及其他信息，您的信息应当适用该第三方的隐私声明或类似政策，我们对任何第三方不当使用或披露由您提供的信息不承担任何法律责任。</p>
<p>一、我们如何收集和使用您的个人信息</p>
<p>我们收集您的个人信息主要是为了您和其他用户能够更容易和更满意地使用赛刻体育。我们的目标是向所有的互联网用户提供安全、有趣及有教益的上网经历。而这些个人信息有助于我们实现这一目标。</p>
<p>（一）我们将通过以下途径收集和获得您的个人信息：</p>
<p>1、您提供的信息。例如：</p>
<p>（1）您在注册赛刻体育的帐号或使用赛刻体育时，向我们提供的信息；</p>
<p>2、我们获取的您的信息。您在使用赛刻体育时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息。</p>
<p>3、我们通过间接方式收集到的您的个人信息。例如：</p>
<p>（1）第三方共享的您的信息。亦即第三方使用赛刻体育时所提供有关您的共享信息。</p>
<p>（2）基于您选择使用的赛刻体育服务，我们可能从关联方、第三方合作伙伴获取您授权共享的相关个人信息。例如，当您使用第三方平台的账号登录赛刻体育服务时，我们将根据您的授权获取该第三方账号下的相关信息，并在您同意本隐私政策后将您的第三方账户与您的赛刻体育账户绑定，使您可以通过第三方账户直接登录并使用赛刻体育。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的信息来源合法的前提下，收集并使用您的这些信息。</p>
<p>（二）我们会出于以下目的，收集和使用您以下类型的个人信息：</p>
<p>您理解并同意，我们希望提供给您的产品和服务是完善的，所以我们会不断改进我们的产品和服务，这意味着随着产品和服务的迭代、拓展、升级等，我们可能会经常推出新的服务或业务功能或重新划分业务功能，并可能需要收集新的个人信息或变更个人信息使用目的或方式。如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会依法通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。在此过程中，您可通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>
<p>1、帮助您完成注册及登录</p>
<p>为便于我们为您提供持续稳定的服务并保障您使用赛刻体育服务的安全性，我们需要您提供基本注册或登录信息，包括手机号码并创建您的账号、用户名和密码。如果您仅需使用浏览、筛选、查看内容服务，您不需要注册或登录及提供上述信息。</p>
<p>如果您提供以下额外信息，将有助于我们给您提供更优的服务体验：您的昵称、头像。但如果您不提供这些信息，并不会影响您使用赛刻体育的基本功能。</p>
<p>同时，我们也向您账号注销的途径，在符合服务协议约定条件及国家相关法律法规规定的情况下，您可以自行在“注销账号”页面按照相应的要求（例如，您可以在赛刻体育客户端“我的—头像—注销账户”，进入注销页面）提交注册账号注销申请。您也可以选择通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>
<p>在您的赛刻体育账号注销之后，我们将停止为您提供赛刻体育服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。</p>
<p>2、维护基础功能的正常运行</p>
<p>在您使用我们的服务过程中，为向您提供浏览、筛选、分享、查看内容服务，并更契合您需求的页面展示、了解产品适配性、识别账号异常状态，保障赛刻体育服务的网络及运营安全，以维护前述基本功能的正常运行，我们可能会在您使用我们的服务过程中或在产品后台运行的状态下直接或者间接地收集、存储关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</p>
<p>（1）日志信息：当您使用我们服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如：您的登录账号、筛选内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、发布记录、关注、收藏及分享。</p>
<p>（2）设备信息：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息。例如：设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、存储空间、设备标识符（IMEI/MAC地址/Android ID/IDFA/Open UDID/GUID/SIM卡 IMSI信息）、软硬件特征信息、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、基站传感器信息）。为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用赛刻体育服务。</p>
<p>请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。</p>
<p>3、为您提供客服或其他用户响应功能</p>
<p>当您联系我们的客服或使用其他用户响应功能时（例如提出售中售后申请、个人信息保护投诉或建议、其他客户投诉和需求），我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的账号与系统安全。我们可能还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
<p>4、为您提供安全保障</p>
<p>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或赛刻体育相关协议规则的情况。我们可能会收集、使用或整合您的帐号信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
<p>5、关于特定功能权限的提示</p>
<p>您理解并同意，部分单项服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及信息的收集和使用。例如：</p>
<p>（1）在您开启网络权限后，可实现使用网络浏览赛刻体育内容；</p>
<p>（2）在您开启设备信息权限后，您允许我们获取您的设备信息以作为您设备的唯一性标识，以便了解产品适配性、识别异常状态。</p>
<p>为向您提供您所选择使用的服务或者保证服务的质量和体验，赛刻体育可能需要您授权开启设备的系统权限，以实现这些权限所涉及信息的收集和使用。如您需要关闭您为使用上述某些特定服务而开启的功能权限，大多数设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
<p>6、基于剪贴板的扩展功能</p>
<p>当您复制文字信息（如短信验证码、聊天内容等），分享或接收被分享信息时，您的剪贴板功能可能会被调用以便实现上述功能。剪贴板信息仅会在您的设备上进行处理，我们不会存储您的剪贴板信息用于任何其他途径。</p>
<p>（三）征得授权同意的例外</p>
<p>但根据相关法律法规规定，以下情形中处理（包括收集、存储、使用、加工、传输、提供、公开、删除等）您的个人信息无需征得您的授权同意：</p>
<p>（1）为订立、履行您作为一方当事人的合同所必需；</p>
<p>（2）为履行法定职责或者法定义务所必需；</p>
<p>（3）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；</p>
<p>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
<p>（5）依照本法规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</p>
<p>（6）法律、行政法规规定的其他情形。</p>
<p>（四）有关敏感个人信息的提示</p>
<p>敏感个人信息，是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。以上由您提供或我们收集您的个人信息中，可能包含您的敏感个人信息，例如银行账号、交易信息、行踪轨迹。请您谨慎并留意敏感个人信息，您同意您的敏感个人信息我们可以按本隐私政策所述的目的和方式来处理。</p>
<p>二、我们如何使用COOKIES或同类技术</p>
<p>我们或我们的合作伙伴可能通过COOKIES或同类技术获取和使用您的个人信息，并将该等信息存储为日志信息。</p>
<p>通过使用COOKIES，我们向用户提供简单易行的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让其用户可以受益。比如，为使得赛刻体育的登录过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录赛刻体育的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在赛刻体育上花费的时间和您所选择的赛刻体育服务。</p>
<p>COOKIES使得我们能更好、更快地为您服务，并且使您在赛刻体育上的经历更高效。然而，您应该能够控制COOKIES是否以及怎样被您的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</p>
<p>我们和第三方合作伙伴可能通过COOKIES或同类技术收集和使用您的个人信息，并将该等信息存储。</p>
<p>我们使用自己的COOKIES或同类技术，可能用于以下用途：</p>
<p>1、记住您的身份。例如：COOKIES或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</p>
<p>您可以通过浏览器或用户选择机制拒绝或管理COOKIES。但请您注意，如果您停用COOKIES，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。</p>
<p>三、我们可能共享、转让或披露的个人信息</p>
<p>（一）共享</p>
<p>我们非常重视保护您的个人信息。除以下情形及相关法律法规规定的例外情形之外，未经您另行同意，我们不会与我们之外的任何第三方共享您的个人信息：</p>
<p>1、为实现我们的服务/功能所必需进行的共享。在某些情况下，我们需要向第三方共享您的信息，以实现我们产品与/或服务的功能，让您正常使用您需要的服务，包括：其他与我们的服务/功能相关的供应商、服务提供商和业务合作伙伴所必需进行的共享；</p>
<p>2、与我们的部分合作伙伴的必要共享。为了必要/合理的业务的顺利开展、满足您的要求、履行我们在相关用户协议或本政策中的义务和行使我们的权利或遵守法律规定等目的，我们可能需要向部分合作伙伴共享您的信息，包括：（1）向提供数据服务（包括数据统计、数据分析等）的合作伙伴共享日志信息、设备信息；（2）向提供产品分析服务（包括应用崩溃分析、网络性能分析、域名解析优化）的合作伙伴共享您的产品使用情况（如崩溃、闪退）的统计性数据；（3）其他与我们的部分合作伙伴的必要共享；</p>
<p>3、与我们的关联方的必要共享。为便于我们基于统一的账号体系向您提供一致化服务以及便于您进行统一管理、保障系统和帐号安全等，您的个人信息可能会在我们和我们的关联方之间进行必要共享，包括为了帮助您节省时间、简化操作流程；</p>
<p>4、实现本政策第一条“我们如何收集和使用个人信息”部分所述的其他目的；</p>
<p>5、履行我们在本政策或我们与您达成的其他协议中的义务和行使我们的权利；</p>
<p>6、应您合法需求，协助处理您与他人的纠纷或争议；</p>
<p>7、应您的监护人合法要求而提供您的个人信息；</p>
<p>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>
<p>（二）转让</p>
<p>1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</p>
<p>2、在获得您的明确同意后，我们会向第三方转让您的个人信息。</p>
<p>（三）披露</p>
<p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：</p>
<p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
<p>2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</p>
<p>（四）共享、转让、披露信息时事先征得授权同意的例外</p>
<p>根据相关法律法规规定，在本政策第一条“我们如何收集和使用个人信息”部分第（三）项所述的情形中，共享、转让、披露您的个人信息无需事先征得您的授权同意。</p>
<p>根据法律规定，分享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
<p>四、我们如何存储和保护个人信息</p>
<p>（一）个人信息的存储</p>
<p>除法律法规或监管部门另有规定外，我们仅在本政策所述目的所必需且最短的时限内存储您的个人信息。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求提前向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</p>
<p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
<p>1、法律法规有明确规定；</p>
<p>2、获得您的授权同意；</p>
<p>3、您使用的赛刻体育服务涉及跨境，我们需要向境外提供您的个人信息的。</p>
<p>针对以上情形，我们会确保依据国家法律法规和相关监管部门的规定执行，并对您的个人信息提供足够的保护。</p>
<p>（二）个人信息的保护</p>
<p>我们非常重视信息安全，我们会采取一切合理可行的措施，保护您的个人信息。</p>
<p>1、数据安全技术措施</p>
<p>我们承诺保证您的个人信息安全。为了防止未经授权的访问、披露或其他类似风险，我们落实了合理的物理、电子和管理措施流程，保护我们从您的移动设备和赛刻体育网站上收集的信息。我们将采取所有合理的措施保护您的个人信息。</p>
<p>2、您的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证您的个人信息具有最高的安全等级。</p>
<p>3、我们将采取所有可行的措施保护您的个人信息。但是，您应当意识到互联网的使用并不总是安全的，因此，我们不能保证在通过互联网双向传输时任何个人信息的安全性或完整性。</p>
<p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。</p>
<p>我们的服务采取了多种加密技术，例如在某些赛刻体育服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。</p>
<p>在个人信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。</p>
<p>我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</p>
<p>4、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。在通过赛刻体育服务与第三方进行沟通时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。</p>
<p>5、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
<p>在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>
<p>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入赛刻体育所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
<p>请您务必妥善保管好您的账号、密码及其他身份要素。您在使用赛刻体育时，我们会通过您的账号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现账号、密码及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
<p>五、如何管理您的个人信息</p>
<p>（一）访问、更新和删除</p>
<p>我们鼓励您更新和修改您的个人信息以使其更准确有效。</p>
<p>如您想查询、修改或删除您的部分个人信息，请登录赛刻体育-我的-头像相关功能页面我们为您提供了相关操作指引和操作设置。对于通过COOKIES或同类技术收集的您的信息，我们还在本政策第二条“我们如何使用COOKIES或同类技术”部分说明了向您提供的选择机制。</p>
<p>您也可以通过本政策“如何联系我们”章节所列的反馈渠道联系我们为您处理。我们将采取适当的技术手段或联系渠道，使您可以访问、更新和删除自己的个人信息或使用赛刻体育服务时提供的其他信息，但法律法规另有规定的除外。</p>
<p>除法律法规另有规定，当您更正、删除您的个人信息时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。</p>
<p>（二）公开与分享</p>
<p>我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关信息，例如，您在赛刻体育中所上传或发布的信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或存储，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。</p>
<p>（三）改变您授权同意的范围</p>
<p>您总是可以选择是否向我们披露个人信息。有些个人信息是使用赛刻体育所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能、注销账号等方式改变您授权我们继续收集信息的范围或撤回您的授权。</p>
<p>当撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</p>
<p>（四）响应您的上述请求</p>
<p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
<p>在以下情形中，我们将无法响应您的请求：</p>
<p>1、与我们履行法律法规规定的义务相关的；</p>
<p>2、与国家安全、国防安全直接相关的；</p>
<p>3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
<p>4、与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
<p>5、我们有充分证据表明您存在主观恶意或滥用权利的；</p>
<p>6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
<p>7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
<p>8、涉及商业秘密的。</p>
<p>六、第三方服务</p>
<p>赛刻体育可能接入第三方提供的其他服务（包括网站或其他服务形式）。</p>
<p>1、您可利用第三方服务登录赛刻体育。这些功能可能会收集您的个人信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；</p>
<p>为保障赛刻体育服务的相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。</p>
<p>（1）用于手机号码一键登录功能;</p>
<p>（2）Ai问答功能</p>
<p>我们会对合作方获取信息的软件工具开发包（SDK）或类似应用程序进行严格的安全评估，以保护您的个人信息安全。以下是我们接入的主要的第三方服务商的信息：</p>

<p>名称：阿里云SDK</p>
<p>第三方主体：阿里云计算有限公司</p>
<p>SDK用途：帮助实现用户一键登录行为</p>
<p>SDK收集的个人信息类型：IP地址、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI），并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志</p>
<p>第三方隐私链接：阿里云官网法律声明及隐私权政策 (aliyun.com)</p>

<p>名称：阿里云百炼SDK</p>
<p>第三方主体：通义云启（杭州）信息技术有限公司</p>
<p>使用场景：使用信息提炼功能、使用AI对话服务、使用DeepSeek智能体</p>
<p>使用目的：提供智能对话服务，包括提供智能问答、输出概要总结、待办事项</p>
<p>个人信息种类：用户输入信息（文本、图片）、音频转写后的文本、文件、提示语</p>
<p>共享方式：服务端API传输</p>
<p>隐私政策链接：https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20231011201849846/20231011201849846.html</p>

<p>SDK名称：极光推送 SDK</p>
<p>第三方主体：深圳市和讯华谷信息技术有限公司</p>
<p>SDK用途：为 APP 用户提供信息推送服务</p>
<p>处理个人信息类型：设备标识信息（IMEI、Serial、IMSI、Android ID）、IP地址。网络信息（包括SSID、BSSID）：可选个人信息，用于推送服务基本业务功能场景中判定模糊位置信息，提升推送触达率。软件列表信息（包括软件列表及软件运行列表信息）优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。</p>
<p>数据处理方式：SDK采集</p>
<p>极光隐私权政策链接：https://www.jiguang.cn/license/privacy</p>
<p>官网链接：https://www.jiguang.cn/</p>

<p>我们接入的部分第三方SDK可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。</p>
<p>七、未成年人保护</p>
<p>我们建议：任何未成年人参加网上活动应事先取得父母或其他监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关个人信息。</p>
<p>我们鼓励监护人指导未成年人使用球赛刻体育。</p>
<p>八、修订和通知</p>
<p>为了给您提供更好的服务，我们可能会根据赛刻体育服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上公布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知（网站公告、推送通知、弹窗提示），本政策所指的重大变更包括但不限于：</p>
<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
<p>2、我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
<p>3、个人信息共享、转让或公开披露的主要对象发生重大变化；</p>
<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
<p>5、我们负责处理个人信息安全的责任部门。联络方式及投诉渠道发生重大变化；</p>
<p>6、其他重要的或可能严重影响您的个人权益的情况发生。</p>
<p>我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用赛刻体育时都查阅我们的隐私政策。</p>
<p>九、如何联系我们</p>
<p>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</p>
<p>电话：19142044013</p>
<p>微信号：q1069551299</p>
<p>一般情况下，我们将在三十天内回复。</p>


  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  setup() {
    onMounted(() => {
      document.title = "隐私政策";
    });
  },
};
</script>

<style scoped>
/* 彻底消除顶部空白 */
.doc-container {
  min-height: 100%;
}

/* h1 标题：居中 + 美观间距 */
h1 {
  text-align: center;
  margin: 0;
  padding: 20px 0 25px 0;   /* 上方留一点呼吸空间，下方与正文保持合适间距 */
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}

/* 正文段落：左右对齐（两端对齐） */
p {
  margin: 0 0 12px 0;       /* 段落底部间距 */
  text-align: justify;      /* 左右对齐 */
  text-justify: inter-ideograph;  /* 中文两端对齐更好看 */
  font-size: 10.5pt;
  font-family: 等线, "Microsoft YaHei", sans-serif;
  line-height: 1.7;         /* 建议增加行高，阅读更舒适 */
}

/* 标题 h2、h3 的样式（如果后续有的话） */
h2, h3 {
  margin: 18px 0 10px 0;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

/* 整体容器样式 */
.doc-container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;         /* 默认左对齐，h1单独居中 */
  color: #2c3e50;
  padding: 0 20px 30px 20px;   /* 左右留白，让正文不贴边，更美观 */
  box-sizing: border-box;
  max-width: 800px;         /* 可选：限制最大宽度，手机和电脑都好看 */
  margin: 0 auto;           /* 可选：内容居中显示 */
}
</style>
